import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { OtpVerify } from "@/components/OtpVerify";

export default function AuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const { setUser } = useAuth() || {};
  const ran = useRef(false);
  const [otp, setOtp] = useState(null); // {pending_token, phone_hint} — dispatcher 2FA step

  const finish = (u) => {
    if (setUser) setUser(u);
    const dest =
      u.role === "dispatcher" ? "/dispatcher"
      : u.role === "driver" ? "/driver"
      : "/customer";
    window.history.replaceState({}, "", window.location.pathname);
    nav(dest, { replace: true, state: { user: u } });
  };

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const hash = loc.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/login", { replace: true });
      return;
    }
    const session_id = m[1];
    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id });
        if (r.data.otp_required) {
          window.history.replaceState({}, "", window.location.pathname);
          setOtp({ pending_token: r.data.pending_token, phone_hint: r.data.phone_hint });
          return;
        }
        finish(r.data);
      } catch (e) {
        console.error("Auth exchange failed", e);
        nav("/login?error=auth", { replace: true });
      }
    })();
  }, [loc.hash, nav, setUser]);

  if (otp) {
    return (
      <div data-testid="auth-callback-otp" className="min-h-screen flex items-center justify-center bg-[#050505] text-[#F5F2EB] px-6">
        <div className="w-full max-w-md border border-white/10 bg-[#0A0A0A] p-8 md:p-12">
          <OtpVerify
            pendingToken={otp.pending_token}
            phoneHint={otp.phone_hint}
            onCancel={() => nav("/login", { replace: true })}
            onSuccess={finish}
          />
        </div>
      </div>
    );
  }

  return (
    <div data-testid="auth-callback" className="min-h-screen flex items-center justify-center bg-[#050505] text-[#F5F2EB]">
      <div className="text-center">
        <div className="font-serif text-3xl text-[#D4AF37] mb-3">Signing you in…</div>
        <div className="overline">Securing your concierge session</div>
      </div>
    </div>
  );
}
